export default __webpack_public_path__ + "static/media/courses.833ae938.jpg";